module.exports = require('history')
